import store from '@/stores/store'
import { getAppDisplayName } from '@/appDisplayNames'

const CmEmbarcador = () => import(/* webpackChunkName: "cm-embarcador" */ '@/components/cm-embarcador.vue')
const Index = () => import(/* webpackChunkName: "cm-embarcador" */ '@/components/cm-embarcador/Index')
const Consult = () => import(/* webpackChunkName: "cm-embarcador" */ '@/components/cm-embarcador/Consult')
const Show = () => import(/* webpackChunkName: "cm-embarcador" */ '@/components/cm-embarcador/show/Index')
const Setting = () => import(/* webpackChunkName: "cm-embarcador" */ '@/components/cm-embarcador/Setting')
const CustomReports = () => import(/* webpackChunkName: "cm-embarcador" */ '@/components/cm-embarcador/CustomReports')

const getAppName = () => getAppDisplayName('cm-embarcador', store.getters.getPartner)

export default {
  children: [
    {
      component: Index,
      meta: {
        breadcrumbs: [{ dynamicName: getAppName }]
      },
      path: '/'
    },
    {
      component: Consult,
      meta: {
        breadcrumbs: [
          { link: '/cm-embarcador', dynamicName: getAppName },
          { name: 'Históricos de Consultas' },
        ]
      },
      path: 'consultas'
    },
    {
      component: Setting,
      meta: {
        breadcrumbs: [
          { link: '/cm-embarcador', dynamicName: getAppName },
          { name: 'Configurações' },
        ]
      },
      path: 'configuracoes'
    },
    {
      component: CustomReports,
      meta: {
        breadcrumbs: [
          { link: '/cm-embarcador', dynamicName: getAppName },
          { name: 'Relatório Customizado' },
        ]
      },
      path: 'custom-reports'
    },
    {
      component: Show,
      meta: {
        breadcrumbs: [
          { link: '/cm-embarcador', dynamicName: getAppName },
          { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
        ]
      },
      path: 'multas/:id',
      props: true
    }
  ],
  component: CmEmbarcador,
  path: 'cm-embarcador'
}
